import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

function ReviewTransactionDetail({ reviewTransactionDetails, authDetails }) {
    const [loading, setloading] = useState(false);

    const authDateValidation = (rowData) => {
        return rowData?.authDate?.slice(0, 10);
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Transaction Review Details</h1>
                </div>
                <div className="Review__Wrapper">
                    <div className="Dialog__Round">
                        <table className="Dialog__Table__Review ">
                            <div className="p-fluid p-formgrid p-grid">
                                <div className="p-field p-col-12 p-md-3">
                                    <tr>
                                        <th>Beneficiary Account Number</th>
                                        <th>Beneficiary Account Title</th>
                                        <th>Beneficiary Address</th>
                                        <th>Beneficiary Email</th>
                                        <th>Beneficiary Name</th>
                                        <th>Collection Account Number</th>
                                        <th>Customer Reference Number</th>
                                        <th>Debit Account Number</th>
                                        <th>Deposit Date</th>
                                        <th>Deposit Slip Amount</th>
                                        <th>Deposit Slip No</th>
                                    </tr>
                                </div>
                                <div className="p-field p-col-12 p-md-3">
                                    <tr>
                                        <td>{reviewTransactionDetails?.beneficiaryAccountNumber || "-"}</td>
                                        <td>{reviewTransactionDetails?.beneficiaryAccountTitle || "-"}</td>
                                        <td>{reviewTransactionDetails?.beneficiaryAddress || "-"}</td>
                                        <td>{reviewTransactionDetails?.beneficiaryEmail || "-"}</td>
                                        <td>{reviewTransactionDetails?.beneficiaryName || "-"}</td>
                                        <td>{reviewTransactionDetails?.collectionAccountNumber || "-"}</td>
                                        <td>{reviewTransactionDetails?.customerReferenceNumber || "-"}</td>
                                        <td>{reviewTransactionDetails?.debitAccountNumber || "-"}</td>
                                        <td>{reviewTransactionDetails?.depositDate || "-"}</td>
                                        <td>{reviewTransactionDetails?.depositSlipAmount || "-"}</td>
                                        <td>{reviewTransactionDetails?.depositSlipNo || "-"}</td>
                                    </tr>
                                </div>
                                <div className="p-field p-col-12 p-md-3">
                                    <tr>
                                        <th>Lodgement User Name</th>
                                        <th>Liquidation Date</th>
                                        <th>Liquidation Reason</th>
                                        <th>Liquidation Status</th>
                                        <th>Lodgement Clearing Date</th>
                                        <th>Lodgement Reason</th>
                                        <th>Lodgement Status</th>
                                        <th>Liquidation UserName</th>
                                        <th>No Of Cheques</th>
                                        <th>No Of Invoices</th>
                                        <th>Depositor Cell No</th>
                                        <th>Depositor Email</th>
                                    </tr>
                                </div>
                                <div className="p-field p-col-12 p-md-3">
                                    <tr>
                                        <td>{reviewTransactionDetails?.ldUserName || "-"}</td>
                                        <td>{reviewTransactionDetails?.liquidationDate || "-"}</td>
                                        <td>{reviewTransactionDetails?.liquidationReason || "-"}</td>
                                        <td>{reviewTransactionDetails?.liquidationStatus || "-"}</td>
                                        <td>{reviewTransactionDetails?.lodgementCdate || "-"}</td>
                                        <td>{reviewTransactionDetails?.lodgementReason || "-"}</td>
                                        <td>{reviewTransactionDetails?.lodgementStatus || "-"}</td>
                                        <td>{reviewTransactionDetails?.lqUserName || "-"}</td>
                                        <td>{reviewTransactionDetails?.noOfCheques || "-"}</td>
                                        <td>{reviewTransactionDetails?.noOfInvoices || "-"}</td>
                                        <td>{reviewTransactionDetails?.depositorCellNo || "-"}</td>
                                        <td>{reviewTransactionDetails?.depositorEmail || "-"}</td>
                                    </tr>
                                </div>
                            </div>
                        </table>
                    </div>
                </div>
            </div>

            <div className="card p-datatable-sm">
                <DataTable header="Authorization Details" loading={loading} value={authDetails} paginator rows={3} emptyMessage="No data found.">
                    <Column field="userName" header="User Name" />
                    <Column field="roleDescription" header="Role description " />
                    <Column field="remarks" header="Remarks" />
                    <Column field="authDate" body={authDateValidation} header="Authorization Date" />
                    <Column field="authStatus" header="Authorization Status" />
                    <Column field="authComments" header="Authorization Comment" />
                </DataTable>
            </div>
        </>
    );
}

export default ReviewTransactionDetail;
